import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editable", "content", "filesSelected", "fileInput"]

  sync() {
    this.contentTarget.value = (this.editableTarget.innerText || "").trim()
  }

  filesChanged() {
    const n = this.fileInputTarget.files ? this.fileInputTarget.files.length : 0
    this.filesSelectedTarget.textContent = `${n} arquivo(s) selecionado(s)`
  }

  openFiles(e) {
    e.preventDefault()
    this.fileInputTarget.click()
  }
}
